import { BulletinMediaItem } from "./types";

/**
 * The entity/media relation, read and written from the one place it is stored.
 *
 * README decision 8: the relation lives on the media item, never on the entity. The design shows it
 * from both sides — chips under an entity card, an "In this media" picker under a file — and both
 * sides go through here, so neither can drift from the other.
 */

/** The files attached to one entity. Derived; there is no list to keep in sync. */
export const mediaForEntity = (
  media: BulletinMediaItem[],
  entityId: string,
): BulletinMediaItem[] =>
  media.filter((item) => item.entityIds.includes(entityId));

/** Attaches or detaches one file/entity pair, whichever side asked for it. */
export const toggleMediaEntity = (
  media: BulletinMediaItem[],
  mediaId: string,
  entityId: string,
): BulletinMediaItem[] =>
  media.map((item) =>
    item.id === mediaId
      ? {
          ...item,
          entityIds: item.entityIds.includes(entityId)
            ? item.entityIds.filter((id) => id !== entityId)
            : [...item.entityIds, entityId],
        }
      : item,
  );

/**
 * Drops every reference to an entity that no longer exists.
 *
 * Deleting an entity is the only way to orphan a link — switching type keeps the row id precisely so
 * the links survive it (decision 11). Without this the id would ride the payload forever, pointing at
 * nothing.
 */
export const detachEntity = (
  media: BulletinMediaItem[],
  entityId: string,
): BulletinMediaItem[] =>
  media.map((item) =>
    item.entityIds.includes(entityId)
      ? { ...item, entityIds: item.entityIds.filter((id) => id !== entityId) }
      : item,
  );
